import { render, staticRenderFns } from "./filmproducer.vue?vue&type=template&id=586cca82&scoped=true&"
import script from "./filmproducer.vue?vue&type=script&lang=js&"
export * from "./filmproducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586cca82",
  null
  
)

export default component.exports